<template>
  <OurPage
    :back-route="backRoute"
    class="access-groups"
    :title="pageTitle"
    width="md"
  >
    <ArticleForm
      ref="articleForm"
      v-model="form"
      :upload-files="uploadFiles"
      :can-add-subsection="canAddSubsection"
      @uploadFiles="uploadFilesMutation"
      @deleteFiles="deleteFileMutation"
    />

    <template #footer-left>
      <OurButton class="button" :text="$t('button.save')" @click="onClickSaveButton" />
      <OurLink :route="backRoute">
        <OurButton class="button" :text="$t('button.back')" variant="secondary" />
      </OurLink>
    </template>
  </OurPage>
</template>

<script>
import ArticleForm from "@/views/settings/base-knowledge/chapter/_components/ArticleForm.vue";
import {
  createArticleMutation,
  deleteFileMutation,
  uploadFilesMutation,
} from "@/views/settings/base-knowledge/chapter/add/gql/mutations";
import apolloMixin from "@/mixins/apollo.mixin";
import { createKnowledgeBaseSectionMutation } from "@/views/settings/base-knowledge/add/gql/mutations";
import {
  canCreateSubsectionAtDepth,
  getKnowledgeBaseSectionMeta,
} from "@/views/settings/base-knowledge/services/sections";

export default {
  name: "ChapterAdd",
  components: { ArticleForm },
  mixins: [apolloMixin],
  data() {
    return {
      sectionDepth: null,
      sectionName: "",
      form: {
        name: "",
        type: "",
        content: "",
        files: [],
        visibleForDealers: false,
      },
      uploadFiles: [],
    };
  },
  computed: {
    canAddSubsection() {
      return canCreateSubsectionAtDepth(this.sectionDepth);
    },

    pageTitle() {
      if (this.form.type === "subsection") {
        return this.$t("title.knowledgeBase.add");
      }

      return this.$t("title.knowledgeBase.addChapter");
    },

    backRoute() {
      return {
        name: "Chapter",
        params: { id: this.$route.params.id },
        title: this.sectionName || this.$t("title.knowledgeBase.chapter"),
      };
    },
  },
  created() {
    this.loadSectionMeta();
  },
  methods: {
    async loadSectionMeta() {
      const sectionMeta = await getKnowledgeBaseSectionMeta(this.$route.params.id);

      this.sectionDepth = sectionMeta.depth;
      this.sectionName = sectionMeta.name || "";
    },

    async uploadFilesMutation(selectedFiles) {
      const { uploadFiles: files } = await this.$post(
        uploadFilesMutation,
        { files: selectedFiles },
        { withLoader: false, withNotify: false }
      );

      this.uploadFiles = files;
    },

    async deleteFileMutation(id) {
      await this.$post(deleteFileMutation, { id }, { withLoader: false, withNotify: false });
    },

    async onClickSaveButton() {
      this.$refs.articleForm.emitForm();

      if (this.form.isValid) {
        if (this.form.type === "subsection") {
          const { createKnowledgeBaseSection } = await this.$post(
            createKnowledgeBaseSectionMutation,
            {
              name: this.form.name,
              visibleForDealers: this.form.visibleForDealers,
              parentId: this.$route.params.id,
            },
            {
              delaySuccessNotify: true,
            }
          );

          if (createKnowledgeBaseSection.id) {
            await this.$router.push({ name: "Chapter", params: { id: this.$route.params.id } });
          }

          return;
        }

        const { createArticle } = await this.$post(
          createArticleMutation,
          { sectionId: this.$route.params.id, ...this.form },
          {
            delaySuccessNotify: true,
          }
        );

        if (createArticle.id) await this.$router.push({ name: "Chapter" });
      }
    },
  },
};
</script>
